import { render, staticRenderFns } from "./FileUploadItem.vue?vue&type=template&id=c2b86b9a&scoped=true&lang=pug"
import script from "./FileUploadItem.vue?vue&type=script&lang=js"
export * from "./FileUploadItem.vue?vue&type=script&lang=js"
import style0 from "./FileUploadItem.vue?vue&type=style&index=0&id=c2b86b9a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b86b9a",
  null
  
)

export default component.exports